import React from "react";
import Button from "@mui/material/Button";
import { useHistory } from "react-router-dom";
import { KeyValue, Query } from "../interfaces";

interface Props {
  routerHistory: KeyValue;
  resetState: (state: Query) => void;
  setRouterHistory: (
    routerField: string,
    routerValue: string[] | KeyValue[],
  ) => void;
  buttonLabel?: string;
  updateFormField?: string;
}
function BackToResultsButton({
  routerHistory,
  resetState,
  setRouterHistory,
  buttonLabel,
  updateFormField,
}: Props) {
  const history = useHistory();

  function backButton() {
    history.push(routerHistory.backResultHist.pop());
    let prevState = routerHistory.backResultState.pop() as Query;
    if (updateFormField) {
      prevState = {
        ...prevState,
        ui: { ...prevState.ui, updateFormField: updateFormField },
      };
    }
    resetState(prevState);
    setRouterHistory("backResultHist", routerHistory.backResultHist);
    setRouterHistory("backResultState", routerHistory.backResultState);
  }

  return routerHistory?.backResultHist?.length ? (
    <Button variant="contained" color="secondary" onClick={backButton}>
      {buttonLabel ? buttonLabel : "Back to Results"}
    </Button>
  ) : (
    <></>
  );
}

export default BackToResultsButton;
